import { graphql } from "~/lib/graphql";

export const VideoListFragment = graphql(`
  fragment VideoListFragment on VideoListRecord {
    __typename
    id
    video {
      id
      title
      abstract(markdown: false)
      video {
        provider
        providerUid
        thumbnailUrl
        url
        title
      }
    }
  }
`);
